<div #mainBox class="duration-box"  [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" 
     (clickOutside)="onClickOutside()"
     [additionalElementRefs]="extraBoxes">
    <div class="flag flex-column no-select" [class.flag-all-trials]="remainingTrials<=0"  (mousedown)="startLongPress()" (mouseup)="endLongPress($event)" (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)" (touchcancel)="endLongPress($event)">

        <span class="badge-time" *ngIf="isStarted">{{timerString()}}</span>
        <span class="badge-time-goal" *ngIf="isStarted">{{getDurationFormatted()}}</span>
        <div class="duration-container" [class.blinking-effect]="isAlarmRinging">
            <div class="duration-controls">
                <button *ngIf="!isStarted" (click)="startTimer()" class="duration-button start-button">Start</button>
                <button *ngIf="isStarted" (click)="stopTimer()" class="duration-button stop-button">Stop</button>
            </div>
            <div class="flag-text">{{ text }}

                <span class="sd-text">{{target?.DiscriminativeStimulus}}</span>

                <span class="sd-text">Goal: {{getDurationForDisplay()}}</span>
            </div>
        </div>
        <span class="badge badge-left" (click)="showExtra()">{{ amountOfTimes }}</span>
        
        <button class="badge-bottom-left" [class.target-note-new]="target?.HasUnreadTargetNoteForStaff" (click)="openDetails($event)" >?</button>
        <button class="badge-bottom-right" (click)="openDetails($event)" title="Remaining desired Trials" *ngIf="remainingTrials>0"> {{remainingTrials}}</button>   
    </div>
</div>

@if (detailsOpened) {
    <app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
    }
<div #extraBox class="extra-container"  [class.hide]="!extraOpened">
    <div class="extra-close" (click)="closeExtra()">X</div>
    <div class="extra-container-textbox">
        <div *ngFor="let time of times" class="extra-text">
            <div class="float-right extra-list-trash-icon pointer" (click)="deleteData(time)"><i class="pi pi-trash"></i></div>
            <div>{{ ' @ ' + time.FormattedDate }}</div>
            <div>{{ time.Text}}</div>
        </div>
    </div>
</div>
